import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

const useSelectedChassisNumber = (): string | null => {
  const [searchParameters] = useSearchParams();
  return useMemo(() => searchParameters.get('chassisNumber'), [searchParameters]);
};

export default useSelectedChassisNumber;
